module.exports = __webpack_public_path__ + "static/media/transferencia-bancaria.d674f822.png";